var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M120-240v-80h720v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z"}));
}

Menu.defaultProps = {"height":"24px","viewBox":"0 -960 960 960","width":"24px","fill":"#e3e3e3"};

module.exports = Menu;

Menu.default = Menu;
